const ENTITY_TYPE_ICONS = {
  'Practice': ['fas', 'house-medical'],
  'Provider': ['fas', 'user-doctor'],
  'Facility': ['fas', 'hospital'],
  'Organization': ['far', 'building'],
  'Contract': ['fas', 'file-lines'],
  'Contract Cohort': ['fas', 'file-lines'],
  'Network': ['fas', 'diagram-project'],
  'Region': ['fas', 'map-pin'],
  'Market': ['fas', 'map'],
  'Staff': ['fas', 'stethoscope'],
  'Location': ['fas', 'map-pin'],
  'Sub-Practice': ['fas', 'house-medical'],
  'Practice Liaison': ['fas', 'user'],
  'Central Support Staff': ['fas', 'user'],
  'Market Leaders': ['fas', 'user'],
  'Market President': ['fas', 'user'],
  'Payer': ['far', 'building'],
  'Group': ['fas', 'people-group'],
  'TIN': ['fas', 'hashtag'],
  'PO': ['fas', 'folder-tree'],
};

const PERSON_KEYWORDS = ['staff', 'liaison', 'leader', 'president', 'director', 'manager', 'nurse', 'doctor', 'provider'];
const DEFAULT_ICON = ['far', 'building'];

export function getEntityIcon(entity, fallback = DEFAULT_ICON) {
  const raw = entity?.icon || entity?.entity_icon;
  if (raw) {
    try {
      if (Array.isArray(raw)) return raw;
      if (typeof raw === 'string') return JSON.parse(raw);
    } catch {
      // fall through to type lookup
    }
  }

  const typeName = entity?.entity_type_name || entity?.type_name || '';
  if (typeName && ENTITY_TYPE_ICONS[typeName]) {
    return ENTITY_TYPE_ICONS[typeName];
  }

  // Heuristic: if the type name contains a person-like keyword, use person icon
  if (typeName && PERSON_KEYWORDS.some((kw) => typeName.toLowerCase().includes(kw))) {
    return ['fas', 'user'];
  }

  return fallback;
}
